import { createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { AppStatusInterface } from '../types';

export default createSlice({
  name: REDUX_STORE_SLICES.APP_STATUS,
  initialState: {
    environment: import.meta.env.VITE_MODE,
    cookiesConsent: undefined,
  },
  reducers: {
    setEnvironment: (state: AppStatusInterface, action) => {
      state.environment = action.payload;
    },
    setCookieConsent: (state: AppStatusInterface, action) => {
      state.cookiesConsent = action.payload;
    },
  },
});

export const props = (state: AppStatusInterface) => state;
